import * as FIELD_NAME from 'constant/form-item-names'
import React, { useEffect } from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import NameInput from 'view/component/form-items/name-input'
import IntroductionInput from 'view/component/form-items/introduction-input'
import OrganisationSelect from 'view/component/form-items/category-org-select'
import UserTypeSelect from 'view/component/form-items/category-user-type-select'
import SiteSelect from 'view/component/form-items/site-select'
import SpecialGroupSelect from 'view/component/form-items/special-group-select'
import QlikUrlInput from 'view/component/form-items/qlik-url-input'

const CategoryForm = ({ category, categoryUuid, form, sites, subCat }) => {
  useEffect(() => {
    if (category) {
      category.landing_page = !!category.qlik_url
    }

    form.setFieldsValue(category)
  }, [category])
  return (
    <Form
      form={form}
      layout='vertical'
      onFieldsChange={(changedFields) => {
        if (changedFields[0].name[0] === FIELD_NAME.SPECIAL) {
          form.setFieldsValue({ user_type_uuids: [] })
        } else if (changedFields[0].name[0] === FIELD_NAME.SITES) {
          form.setFieldsValue({ special: false })
        } else if (changedFields[0].name[0] === FIELD_NAME.LANDING_PAGE) {
          form.setFieldsValue({ qlik_url: '' })
        }
      }}
    >
      <NameInput />
      <IntroductionInput />
      {!subCat &&
        <QlikUrlInput
          category={true}
          qlikUrl={category?.qlik_url}
          required={false}
        />
      }
      <OrganisationSelect categoryUuid={categoryUuid} />
      {sites && <SiteSelect sites={sites} />}
      <SpecialGroupSelect
        categoryUuid={categoryUuid}
        sites={sites}
      />
      <UserTypeSelect categoryUuid={categoryUuid} />
    </Form>
  )
}

CategoryForm.propTypes = {
  category: PropTypes.object,
  categoryUuid: PropTypes.string,
  form: PropTypes.object,
  sites: PropTypes.array,
  subCat: PropTypes.bool
}

export default CategoryForm
